import _jsx from "@babel/runtime/helpers/jsx";
/* global caiprivacy */
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Button, Glyphicon, ToggledDropdown } from 'reaxl';

/**
 *  Sitemap generates a sitemap in the form of an toggled dropdown for mobile devices and columned link sections for larger viewports
 *
 */

const getColumn = column => [].concat(column);
const renderSitemapItem = (_ref, index, onClick, enableOneTrustFooter) => {
  let {
    callback,
    text,
    pagetype,
    glyph,
    img,
    ...itemRest
  } = _ref;
  const isOneTrust = typeof callback === 'function';

  // If this is a OneTrust-related link but OneTrust is disabled, don't render it
  if (isOneTrust && !enableOneTrustFooter) {
    return null;
  }
  const handleClick = e => {
    const data = {
      type: 'main',
      text,
      pagetype
    };
    if (onClick) {
      onClick(e, data);
    }
    if (callback && typeof caiprivacy !== 'undefined') {
      e.preventDefault();
      callback();
    }
    return true;
  };
  return /*#__PURE__*/_jsx("li", {
    className: "margin-top-2"
  }, `${itemRest.href || text}/${pagetype}-${index}`, isOneTrust ? /*#__PURE__*/React.createElement(Button, Object.assign({}, itemRest, {
    onClick: handleClick,
    bsStyle: "text"
  }), text, glyph && /*#__PURE__*/_jsx(Glyphicon, {
    className: "margin-left-2",
    glyph: glyph
  })) : /*#__PURE__*/React.createElement("a", Object.assign({}, itemRest, onClick && {
    onClick: handleClick
  }, {
    className: "link-undecorated"
  }), text, glyph && /*#__PURE__*/_jsx(Glyphicon, {
    className: "margin-left-2",
    glyph: glyph
  })));
};
const renderSingleDropdown = (_ref2, onClick, enableOneTrustFooter) => {
  let {
    title,
    items
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: "dropdown"
  }, title, /*#__PURE__*/_jsx(ToggledDropdown, {
    containerElement: "div",
    collapseElement: "ul",
    collapseClassName: "list-unstyled",
    className: "dropdown-panel-content",
    showCaret: false,
    labelText: title,
    id: title.replace(/\s/ig, ''),
    closeGlyph: "menu-up",
    openGlyph: "menu-down"
  }, title.replace(/\s/ig, ''), items.map((item, index) => renderSitemapItem(item, index, onClick, enableOneTrustFooter))));
};
const renderColumns = (data, colNumber, onClick, enableOneTrustFooter) => data.map((column, index) => /*#__PURE__*/_jsx("div", {
  className: `sitemap-column col-sm-${colNumber}`
}, `column-${index}-${colNumber}`, getColumn(column).map(item => renderSingleDropdown(item, onClick, enableOneTrustFooter))));
function StaticSitemap(_ref3) {
  let {
    data = [],
    onClick,
    className,
    enableOneTrustFooter,
    ...rest
  } = _ref3;
  const colNumber = Math.round(12 / data.length);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "sitemap",
    "data-testid": "sitemap",
    className: clsx('sitemap display-flex gap-sm-5 flex-column row flex-sm-row', className)
  }, rest), renderColumns(data, colNumber, onClick, enableOneTrustFooter));
}
export default StaticSitemap;